import * as React from 'react';
import axios from 'axios';
import {
  Cart, GalleryFile
} from '../../iMonCompte';
import {getShopRefInStorage, getUserId, sessionExpire} from '../../MonCompteAction';
import { renderAlert } from '../../RenderCommon';
import {getHostApi, getRequestConfig} from '../../../../utils';
import {
  canGallerie,
  canValidate, deleteUploadRequest,
  getFile,
  getUploadRequest, postUploadRequest, putUploadRequest
} from '../UploadActions.api';
import {ModalFileVerification} from "./ModalFileVerification";
import {BounceLoader} from "../../BounceLoader";
import {Gallery} from "./Gallery";
import {badQualityMsg, detectBackground, generateFormData} from "../UploadUtils";
import {ThumbnailUploadContainer} from "./ThumbnailUploadContainer";
import {cmjnData} from "./UpdateCmjn";
import {SwitchBtn} from "../../SwitchBtn";
import {UploadBtn} from "./UploadBtn";
import { GenerateTextureFiles, IFilesForCreationId } from './iUpload';
export default class RenderImportButton extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      displayContainerButtons: 'flex',
      displayChargement: false,
      fromGallery: '0',
      textAlert: '',
      showAlert: false,
      classAlert: '',
      isNonConforme: false,
      openZoom: false,
      openGallery: false,
      openDelete: false,
      openBroderie: false,
      reUseDimensions: false,
      dimensionsModifiees: false,
      canGalerie: false,
      dimensions: [],
      useBatAuto: this.props.activateBatAuto ? true : false,
      batAutoRotation: 0,
      batAutoColor: '',
      batAutoTrim: false,
      applyOutline: false,
      colorOutline: '#000000',
      batAutoRemoveBackground: false,
      displayColorPicker: false,
      rowValidationVisuelChecked : this.props.rowValidationVisuelChecked,
      editorMenuOpen: false,
      originalFileInfos: [],
      statutVisuel: null,
      validationBat: this.props.order.validation_bat,
      reuploadByOperator: false,
      displayFinesse: false,
      nonConforme: false,
      isStylo: false,
      oldCmdFromGallery: null,
      surfaceId : this.props.surface.id,
      emplacementId : this.props.emplacement.id,
      backgroundCanBeRemoved: false
    };
  }

  componentDidMount() {
    this._canValidate();
    this._isReuploadByOperator();
    // gallerie à revoir le bat auto
    this._canGallerie();
    if (this.props.paniers[0]) {
      this._getFile(this.props.paniers[0].idCaddies);
      if(this.props.paniers[0].isBeforeUploadReadyToUpload) {
        this._uploadImage(this.props.paniers, false, false, false, true);
      }
    }
  }
  componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any) {
    this._isReuploadByOperator();
    if(prevState.surfaceId !== this.state.surfaceId && parseInt(this.state.surfaceId) > 0 && this.props.paniers[0]) {
        this._getStatusVisuel(this.props.paniers[0].idCaddies);
      }
  }

  _canValidate() {
    canValidate(this.props.order.idCommande).then((response: boolean) => {
      this.props.onCanValidate(response);
    });
  }
  _canGallerie(){
    const data = {
      idCaddies: JSON.stringify(this.props.paniers.map((panier: Cart) => {return panier.idCaddies;}))
    };
    canGallerie(this.props.order.idCommande, data).then((response: boolean) => {
      this.setState({ canGalerie: response && this.props.canGallerie });
    });
  }
  _getFile = (idCaddies: string) => {
    getFile(this.props.order.idCommande, idCaddies, this.state.surfaceId,this.state.emplacementId).then((response: any) => {
      if (response && response.data.files) {
        this.setState({
          fileRegisteredOriginalName: response.data.files.fichier_origine,
          fileRegisteredOriginalType: response.data.files.type_mime_id,
          fileRegisteredId: response.data.files.id,
          fileRegisteredSize: response.data.files.poids,
          fileRegisteredDimensions: response.data.files.dimensions,
          fileRegisteredCreationId: response.data.files.creationId,
          fromGallery: response.data.files.fromGallery,
          isNonConforme: response.data.files.non_conforme,
          fileRegisteredRenamedName: response.data.files.filename,
          surfaceEmplacementId: response.data.files.surfaceEmplacementId,
          oldCmdFromGallery: response.data.files?.oldCmdFromGallery,
          fileSourceBeforeOrder: response.data.files?.fileSourceBeforeOrder,
          fileCustomer: response.data.files?.fichier,
        }, () => {
          this._getPreview(idCaddies, true);
        });
      }
    });
  }

  _getPreviews = (idCaddies: string, forceUpdate: boolean = true) => {
    if (this.state.fileRegisteredId) {
      let url = `${getHostApi()}/customers/${getUserId()}/orders/${this.props.order.idCommande}/items/${idCaddies}/surfaces/${this.state.surfaceId}/locations/${this.state.emplacementId}/images-bat-auto/${this.state.fileRegisteredId}`;
      url = `${url}/previews`;
      getUploadRequest(url).then((response: any) => {
        if (response && response.data) {
          const results = {
            preview: response.data.previews.preview,
            bat: response.data.previews.bat,
            finesse: response.data.previews.finesse,
            dilatation: response.data.previews.dilatation,
            batOriginal: response.data.previews?.batOriginal
          };
          if (forceUpdate && results && results.preview && results.preview.filename) {
            results.preview.filename = results.preview.filename + '&' + Date.now();
            results.bat.filename = results.bat.filename + '&' + Date.now();
            if(results.finesse) {
              results.finesse.filename = results.finesse.filename + '&' + Date.now();
            }
            if(results.dilatation) {
              results.dilatation.filename = results.dilatation.filename + '&' + Date.now();
            }
          }
          this.setState({
            preview: results.preview,
            bat: results.bat,
            finesse: results.finesse,
            dilatation: results.dilatation,
            displayFinesse: results.finesse !== 'undefined',
            batOriginal: results.batOriginal
          }, async () => {
            this._getAllImgPath(results);
            this._sendPreview();
          });
        }
      });
    }
  }

  _getOriginalFileInfos = (idCaddies: string) => {
    if (this.state.fileRegisteredId) {
      let url = `${getHostApi()}/customers/${getUserId()}/orders/${this.props.order.idCommande}/items/${idCaddies}/surfaces/${this.state.surfaceId}/locations/${this.state.emplacementId}/images-bat-auto/${this.state.fileRegisteredId}`;
      url = `${url}/origin-file-infos`;
      getUploadRequest(url).then((response: any) => {
        if (response && response.data) {
          this.setState({originalFileInfos: response.data});
        }
      });
    }
  }

  _getStatusVisuel = (idCaddies: string) => {
    if (this.state.fileRegisteredId) {
      let url = `${getHostApi()}/customers/${getUserId()}/orders/${this.props.order.idCommande}/items/${idCaddies}/surfaces/${this.state.surfaceId}/locations/${this.state.emplacementId}/images-bat-auto/${this.state.fileRegisteredId}`;
      url = `${url}/statut-visuel`;
      getUploadRequest(url).then((response: any) => {
        if (response && response.data) {
          this.setState({statutVisuel: response.data});
        }
      });
    }
  }

  _getNonConforme = (idCaddies: string) => {
    if (this.state.fileRegisteredId) {
      const url = `${getHostApi()}/customers/${getUserId()}/orders/${this.props.order.idCommande}/items/${idCaddies}/surfaces/${this.state.surfaceId}/locations/${this.state.emplacementId}/images-bat-auto/${this.state.fileRegisteredId}/non-conforme`;
      getUploadRequest(url).then((response: any) => {
        if (response && response.data) {
          this.setState({nonConforme: response.data});
        }
      });
    }
  }

  _getDimensionsBatAuto = (idCaddies: string) => {
    if (this.state.fileRegisteredId) {
      let url = `${getHostApi()}/customers/${getUserId()}/orders/${this.props.order.idCommande}/items/${idCaddies}/surfaces/${this.state.surfaceId}/locations/${this.state.emplacementId}/images-bat-auto/${this.state.fileRegisteredId}`;
      url = `${url}/dimensions-surface`;
      getUploadRequest(url).then((response: any) => {
        if (response && response.data) {
          const largeurIsModified = (response.data.dimensions.surface.largeur.toFixed(2) !==  response.data.dimensions.surface_origin.largeur.toFixed(2)) && (response.data.dimensions.surface.largeur.toFixed(2) !==  response.data.dimensions.surface_origin.hauteur.toFixed(2)) ;
          const hauteurIsModified = (response.data.dimensions.surface.hauteur.toFixed(2) !==  response.data.dimensions.surface_origin.hauteur.toFixed(2))  && (response.data.dimensions.surface.hauteur.toFixed(2) !==  response.data.dimensions.surface_origin.largeur.toFixed(2))  ;
          const isModified = largeurIsModified && hauteurIsModified ;
          const isStylo = this.props.pictogramme &&  this.props.pictogramme.nom &&  this.props.pictogramme.nom.includes("stylo");
          this.setState({dimensions: response.data.dimensions.surface, dimensionsData: response.data.dimensions, reUseDimensions:false, dimensionsModifiees: isModified, isStylo: isStylo });
        }
      });
    }
  }

  _getCmjnByCaddiesSurface = (idCaddies: string) => {
    if (this.state.fileRegisteredId) {
      getUploadRequest(this._stringUrlCmjn(idCaddies)).then((response: any) => {
        if (response?.data) {
          this.setState({cmjnCs: response.data});
          this.props.onCmjnUpdated(response.data);
        }
      });
    }
  }

  _stringUrlCmjn = (idCaddies: string) : string => {
    return `${getHostApi()}/customers/${getUserId()}/orders/${this.props.order.idCommande}/items/${idCaddies}/surfaces/${this.state.surfaceId}/locations/${this.state.emplacementId}/images-bat-auto/${this.state.fileRegisteredId}/cmjn`;
}

  _updateCmjnByCaddiesSurface = (idCaddies: string, cmjnData: cmjnData) => {
    if (this.state.fileRegisteredId) {
      putUploadRequest(this._stringUrlCmjn(idCaddies), cmjnData).then((response: any) => {
        if (response && response.data) {
          this.setState({cmjnCs: response.data});
          this.props.onCmjnUpdated(response.data);
        }
      });
    }
  }

  _fetchFusionData = () => {
    const url = `${getHostApi()}/customers/${getUserId()}/orders/${this.props.order.idCommande}/fusion`;
    getUploadRequest(url).then((response: any) => {
      if (response && response.data &&  response.data.fusion) {
      this.setState({ fusionData: response.data.fusion});
    }
    });
  }

  _uploadImage = (caddies: Cart[], fileIsUpload = false, rollback: boolean = false, fromGallery = false, onFirstLoad = false) => {
      caddies[0].isBeforeUploadReadyToUpload = this.state.withBeforeUploadStatusId ? this.state.withBeforeUploadStatusId === 2 : caddies[0].isBeforeUploadReadyToUpload;
      caddies[0].isBeforeUploadReadyToUpload = onFirstLoad ? caddies[0].isBeforeUploadReadyToUpload : false;
      const formData =  this._createFormData(caddies, fileIsUpload, rollback, fromGallery);
      if((formData?.get('file')?.size ?? 0) / 1048576 > 20) {
        this._displayAlert("La taille du fichier dépasse 20Mo.", 'alert-danger-custom');
      } else {
        this._prepareToUpload(caddies, fileIsUpload);
        const url = `${getHostApi()}/customers/${getUserId()}/orders/${this.props.order.idCommande}/images-bat-auto`;
  
      if(caddies[0].isModel3d) {
        this.props.updateTextureGlb(caddies[0].creation_id, true);
      }

      postUploadRequest(url, formData).then((response: any) => {
          if (response && response.data && response.data.response?.['no-file-before'] === undefined) {
            if(response.data.response.alternateSfcChanged) {
              this.props.onChangeSurface(response.data.response.sfcAlternate.surfaceId,  response.data.response.sfcAlternate.surfaceName);
            } else {
            this._actionsToDoIfUploadOk(response.data.response, caddies[0].idCaddies);
            }
            if(this.props.paniers[0].isModel3d) {
              this._generateGlbTexture(response.data.response.creationId, response.data.response.uploadDir, response.data.response.filesForCreationId);
            }
          } else if (response && response?.data?.response?.['no-file-before'] === undefined) {
            this.setState({
              displayContainerButtons: 'flex',
              selectedFileName: '',
            }, () => {
              if (this.props.paniers[0]) {
                this._getPreview(this.props.paniers[0].idCaddies, true);
              }
              this._displayAlert(response, 'alert-danger-custom');
            });
          } else if (response && response?.data?.response?.['no-file-before'] !== undefined) {
            this.setState({
              displayContainerButtons: 'flex',
              selectedFileName: ''
            });
          }
        }).catch((error) => {
          console.log(error);
        })
        .finally(() => this.setStateByKeyValue('displayChargement', false));
      }
  }

  _getImgPath(type: string, nameFile: string, pathFile: string) {
    const validated = pathFile.indexOf('travail.auto') != -1;
    const url = `${getHostApi()}/customers/${getUserId()}/orders/${this.props.order.idCommande}/image-files?nom=${nameFile}&numCommande=${this.props.order.numCommande}&path=${pathFile}&validated=${validated}&xsrf=${localStorage.getItem('xsrfToken')}&cache=${Date.now()}`;
    getUploadRequest(url).then((response: any) => {
      if (response && response.status == 200) {
        const nextState = { displayContainerButtons: 'none'};
        if(type == 'bat') {
          Object.assign(nextState, {pathLoadBat : url});
        } else if (type == 'preview') {
          Object.assign(nextState, {pathLoadPreview : url});
        } else if (type == 'finesse') {
          Object.assign(nextState, {pathLoadFinesse : url});
        } else if (type == 'dilatation') {
          Object.assign(nextState, {pathLoadDilatation : url});
        }else if (type == 'batOriginal') {
          Object.assign(nextState, {pathBatOriginal : url});
        }
        this.setState(nextState);
      }
    });
  }

  _deleteFile = (idCaddies: string) => {
    let url = `${getHostApi()}/customers/${getUserId()}/orders/${this.props.order.idCommande}/items/${idCaddies}/surfaces/${this.state.surfaceId}/locations/${this.state.emplacementId}/images-bat-auto`;
    if (this.state.fileRegisteredId) {
      url = `${url}/${this.state.fileRegisteredId}`;
    }
    deleteUploadRequest(url).then((response: any) => {
      this.setState({
        displayContainerButtons: 'flex',
        fileRegisteredId: '',
        selectedFileName: '',
        fromGallery: '0',
        preview: null,
        dimensions: [],
        dimensionsData: [],
        statutVisuel: null,
        nonConforme: false,
        pathLoadFinesse: ''
      }, () => {
        this._getFile(idCaddies);
        this._sendPreview();
        this._canValidate();
        this._resetCustomOptions();
        if (this.props.onDeleteFile) {
          this.props.onDeleteFile();
        }

        if(response.data.files && this.props.paniers[0].isModel3d) {
          this.props.updateTextureGlb(response.data.files.creationId, true);
          this._generateGlbTexture(response.data.files.creationId, response.data.files.uploadDir, response.data.files.filesForCreationId);
        }
      });
    })
  }

  _onDownloadFile = async (event: React.MouseEvent<HTMLSpanElement>, type: string) => {
    const tiff = this.state.fileRegisteredCreationId + "-" + this.state.surfaceEmplacementId;
    let url = `${getHostApi()}/customers/${getUserId()}/orders/${this.props.order.idCommande}/image-files?nom=${tiff}.tiff&numCommande=${this.props.order.numCommande}&path=/travail.auto/&validated=true&xsrf=${localStorage.getItem('xsrfToken')}&cache=${Date.now()}`;
    const cartId = this.props.paniers[0].idCaddies;
    if(type == "source") {
      url = `${getHostApi()}/customers/${getUserId()}/orders/${this.props.order.idCommande}/image-files?type=source&cartId=${cartId}&sfcEmplacementId=${this.state.surfaceEmplacementId}&fileRegisteredId=${this.state.fileRegisteredId}&numCommande=${this.props.order.numCommande}&path=/&validated=true&xsrf=${localStorage.getItem('xsrfToken')}&cache=${Date.now()}`;
    }
    if(type == "sourceOperateur" && this.state.originalFileInfos?.fileIdFromOperateurLink) {
      url = `${getHostApi()}/customers/${getUserId()}/orders/${this.props.order.idCommande}/image-files?nom=${this.state.originalFileInfos?.fileIdFromOperateurLink}&numCommande=${this.props.order.numCommande}&path=/&validated=true&xsrf=${localStorage.getItem('xsrfToken')}&cache=${Date.now()}`;
    }
    if(type == "sourceBeforeOrder") {
      url = `${getHostApi()}/customers/${getUserId()}/orders/${this.props.order.idCommande}/image-files?type=sourceBeforeOrder&nom=${this.state.fileSourceBeforeOrder}&numCommande=${this.props.order.numCommande}&path=/&validated=true&xsrf=${localStorage.getItem('xsrfToken')}&cache=${Date.now()}`;
    }
    if(type == "embroidery") {
      url = `${getHostApi()}/customers/${getUserId()}/orders/${this.props.order.idCommande}/embroidery-files`;
    }
    const config = {...getRequestConfig(), responseType: 'blob'};
    getUploadRequest(url, config).then((response: any) => {
      if (response && response.status == 200) {
        const file = new Blob([response.data])
        const imgURL = window.URL.createObjectURL(file);
        const tmpLink = document.createElement('a');
        let extension = "zip";
        let nameFile = this.props.order.numCommande.split('-')[2] + "-embroidery";
        if(type !== "embroidery") {
          extension = type == "source" ? this.state.fileRegisteredOriginalName.split('.')[1] : "tiff";
          extension = type == "sourceBeforeOrder" ? this.state.fileSourceBeforeOrder.split('.')[1] : extension;
          extension = type == "sourceOperateur" ? this.state.originalFileInfos?.fileIdFromOperateurLink.split('.')[1] : extension;
  
          if(this.state.originalFileInfos?.file?.extension && type == "source") {
            extension = this.state.originalFileInfos.file.extension;
          }
  
          nameFile = type == "source" ? this.props.order.numCommande.split('-')[2] + "-" + this.state.originalFileInfos?.original_file_id : this.props.order.numCommande.split('-')[2] + "-" + tiff;
          nameFile = type == "sourceOperateur" ? "operateur-" + this.props.order.numCommande.split('-')[2] + "-" + this.state.originalFileInfos?.fileIdFromOperateur : nameFile;
          nameFile = type == "sourceBeforeOrder" ? "sourceBeforeOrder-" + this.props.order.numCommande.split('-')[2] + "-" + this.state.originalFileInfos?.original_file_id : nameFile;  
        }
        
        tmpLink.href = imgURL;
        tmpLink.setAttribute('download',  nameFile + "." + extension);
        tmpLink.click();
      }
    });
  }

  _copyFile = (idCaddies: string) => {
    this.setState({
      fileRegisteredOriginalName: this.state.selectedFile.name,
      displayContainerButtons: 'none',
      displayChargement: true
    }, () => {
      const formData = this._createFormData(this.props.paniers);
      formData.set('file', this.state.selectedFile.creation_id + "-" + this.state.selectedFile.surfaceEmplacementId + ".tiff");
      const url = `${getHostApi()}/customers/${getUserId()}/orders/${this.props.order.idCommande}/items/${idCaddies}/surfaces/${this.state.surfaceId}/images`;
      postUploadRequest(url, formData, getRequestConfig()).then((response: any) => {
        if (response && response.data) {
          this._actionsToDoIfCopyOk(response.data.response, idCaddies);
        }
      }).catch((error) => {
        console.log(error);
        this._actionsToDoIfCopyNotOk(error.response);
      });
    });
  }

  _isReuploadByOperator() {
    const reuploadAdminBatValide = (this.props.isInternalUserAdmin && !this.props.customerView) &&
      this.props.order.validation_bat == '2' && this.props.order.confirmationFichier == '1' &&
      (this.props.order.StatutCommande == '5' || this.props.order.StatutCommande == '6' || this.props.order.StatutCommande == '7');
    const reuploadBtnAdminBatValide = reuploadAdminBatValide && this.state.originalFileInfos?.statutLigneMarquageId === 2;
    const reuploadByOperator = ((this.props.order.StatutCommande == '5') && (this.state.fileRegisteredId || this.state.fileRegisteredId !== '') && this.props.order.confirmationFichier == '1' &&  (this.props.isInternalUser && !this.props.customerView) && this.state.validationBat == '0') || reuploadBtnAdminBatValide;
    if(reuploadByOperator !== this.state.reuploadByOperator) {
      this.setState({reuploadByOperator: reuploadByOperator});
    }
  }

  _getAllImgPath = (data: any) => {
    for(const index in data) {
      const element = data[index];
      if(element && element.filename && element.path) {
        this._getImgPath(index, element.filename, element.path);
      } else {
        // bon endroit pour ce state ? (suite nettoyage thumbnail)
        this.setState({
          displayContainerButtons: 'none',
        });
      }
    }
  }

  _prepareToUpload = (caddies: Cart[], fileIsUpload: boolean ) => {
    this.setState({displayContainerButtons: 'none', pathLoadPreview: null});
    this.setStateByKeyValue('displayChargement', true);
    this._hideAlert();
  }

  _getPreview = (idCaddies: string, forceUpdate: boolean = false, onlyPreview = false) => {
      if(onlyPreview) {
        this._getPreviews(idCaddies, forceUpdate);
      } else {
        this._getPreviews(idCaddies, forceUpdate);
        this._getOriginalFileInfos(idCaddies);
        this._getStatusVisuel(idCaddies);
        this._getNonConforme(idCaddies);
        this._getDimensionsBatAuto(idCaddies);
        this._getConformity(idCaddies);
        this._getCmjnByCaddiesSurface(idCaddies);
        if(this.props.isInternalUser) {
          //uniquement des infos de debug en interne au cas où, la fusion se fait en back
          this._fetchFusionData();
        }
      }
  }

  _sendPreview = () => {
    if (this.props.onPreviewUpdated) {
      this.props.onPreviewUpdated(this.state.preview);
    }
  }

  _sendDimensions = () => {
    this.props.onDimensionsUpdated(this.state.dimensions);
    this._uploadImage(this.props.paniers, true);
  }

  _createFormData = (caddies: Cart[], fileIsUpload : boolean = false, rollback : boolean = false, fromGallery: boolean = false) => {
    let formData = generateFormData(caddies,fileIsUpload,  {...this.state, ...this.props}, rollback, fromGallery);
    formData = this._customOptionsBatAuto(formData);
    return formData;
  }

  setStateByKeyValue(key: string, value: any){
    this.setState({[key] : value});
  }

  _customOptionsBatAuto  = (formData: any) => {
    if(this.state.batAutoRotation > 0) {
      formData.append('r', this.state.batAutoRotation);
    }
    if(this.state.batAutoColor != '') {
      formData.append('f', this.state.batAutoColor);
    }
    if(this.state.batAutoTrim) {
      formData.append('t', this.state.batAutoTrim);
    }
    if(this.state.batAutoRemoveBackground) {
      formData.append('d', this.state.batAutoRemoveBackground);
    }
    if(this.state.applyOutline) {
      formData.append('c', this.state.colorOutline);
    }
    return formData;
  }

  _actionsToDoIfUploadOk = (response: any, idCaddies: string) => {
    this.setState({
      fileRegisteredId: response.id,
      fileRegisteredSize: response.poids,
      fileRegisteredCreationId: response.creationId,
      fileRegisteredOriginalName: response.fichier_origine,
      fromGallery: response.fromGallery,
      displayChargement: false,
      openDelete: false,
      statutVisuel: null,
      nonConforme: false,
      selectedFileName: '',
      pathLoadFinesse: '',
      withBeforeUploadStatusId: response.withBeforeUploadStatusId,
      backgroundCanBeRemoved: false
    }, () => {
      this._getFile(idCaddies);
      if(response.dimensions && response.dimensions.largeur) {
        this._updateDimensions(response.dimensions);
      }
      this._canValidate();
      if(this.props.onWithBeforeStatusIdUpdated) {
        this.props.onWithBeforeStatusIdUpdated(response.withBeforeUploadStatusId);
      }
      
      if(!this.state.useFileUpload) {
        this._detectBackground(response.uploadDir + "travail.auto/" + response.creationId + "-" + response.filesForCreationId[0].surfaceEmplacementId + ".tiff");
      }
    });
  }

  _generateGlbTexture = (creationId: string, uploadDir: string, filesForCreationId: IFilesForCreationId[]) => {
    this.setStateByKeyValue('displayChargement', true);

    const filesArray: GenerateTextureFiles[] = [];

    filesForCreationId.map(element => {
      filesArray.push(
        {
          idSurfaceEmplacement: element.surfaceEmplacementId,
          filename: uploadDir + "travail.auto/"+ creationId +"-"+ element.surfaceEmplacementId +".tiff",
          overloadDimensions: {
            x: element.largeur,
            y: element.hauteur
          }
        }
      )
    });

    const form = {
      refShop: "TO",
      creationId: uploadDir + "travail.auto/textures/" + creationId,
      isTmp: false,
      resolution: 4096,
      files: filesArray,
      productId: this.props.paniers[0].article.produit.idProduits
    };

    this.props.onQueueGlBTexture(creationId, form);
    this.setStateByKeyValue('displayChargement', false);
  }

  _updateDimensions = (dimensions: any, upload: boolean = true) => {
    this.setState({dimensions : dimensions}, () => {
      if (upload) {
        this._sendDimensions();
      }
    });
  }

  _actionsToDoIfUploadNotOk = (response: any, idCaddies: string) => {
    const errorSplit = response.data.message.split('|');
    if (errorSplit[0] === 'BAT indisponible') {
      this.setState({
        fileRegisteredId: errorSplit[1],
        fileRegisteredSize: errorSplit[2],
      });
    } else {
      this._displayAlert(response.data.message, 'alert-danger-custom');
      this.setStateByKeyValue('displayChargement', false);
      this.setState({
        displayContainerButtons: 'flex',
      })
      if (response.status === 401) { sessionExpire(); }
    }
  }

  _displayAlert = (message: string, className?: string, alertHideContent: boolean = false) => {
    this.setState({
      showAlert: true,
      textAlert: message,
      classAlert: `alert-danger ${className}`,
    });
  }

  _hideAlert = () => {
    this.setState({
      showAlert: false,
      textAlert: '',
    });
  }

  _resetCustomOptions = () => {
    this.setState({
      batAutoRotation: 0,
      batAutoColor: '',
      batAutoTrim: false,
      batAutoRemoveBackground: false,
      displayColorPicker: false,
      showResize: false,
      applyOutline: false,
      colorOutline: '#000000',
      reUseDimensions: false
    });
  }

  _onDeleteFile = async (event: React.MouseEvent<HTMLSpanElement>) => {
    if (this.props.paniers) {
      for (const panier of this.props.paniers) {
        await this._deleteFile(panier.idCaddies);
        if(this.props.marquage.id == 4) {
          this._validateFilsBroderie(panier.idCaddies, true, true)
        }
      }
    }
    this.setState({ statutVisuel: null, nonConforme: false})
  }

  _validateFilsBroderie = (idCaddies: string, isDevalidation: boolean = false, isDeleteFile: boolean = false) => {
    const data = {
      "routeValidateFils": getHostApi() + '/customers/' + getUserId() + '/orders/' + this.props.order.idCommande + '/items/' +
        idCaddies + '/surfaces/' + this.state.surfaceId + '/locations/' + this.state.emplacementId +
        '/images-bat-auto/' + this.state.fileRegisteredId + '/embroidery',
      "dataValidateFils": {surfaceEmplacementId: this.state.surfaceEmplacementId, caddies: this.props.paniers, delete: isDevalidation},
      "routeMiniatureFils": `${getHostApi()}/customers/${getUserId()}/orders/${this.props.order.idCommande}/image-files?numCommande=${this.props.order.numCommande}&path=travail.auto/embroidery/&validated=true&xsrf=${localStorage.getItem('xsrfToken')}&cache=${Date.now()}`
    }
    if(isDeleteFile) {
      axios.put(data.routeValidateFils, {...data.dataValidateFils},
        getRequestConfig()).then((response) => {
        if (response.data) {
          this.setState({
            displayChargement: false
          })
        }
      }).catch((error) => {
        if (error.response.status === 401) { sessionExpire(); }
      });
    }
    return data;
  }

  _onUpdateInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.type === 'file' && event.target.files?.[0] && event.target.value ) {
      this.setState({
        selectedFile: event.target.files?.[0],
        selectedFileName: event.target.value,
      }, async () => {
          this._uploadImage(this.props.paniers);
          const array = {id: this.props.paniers[0].idCaddies+'-'+this.state.surfaceId+'-'+this.state.emplacementId, value: false, galerieFichierId: this.state.fileRegisteredId, surfaceId:this.state.surfaceId, emplacementId:this.state.emplacementId};
          this.props?.handleChangeNonConformeChecked(array);
      });
    }
  }

  changeReUseDim = () => {
    if (this.state.dimensionsModifiees || this.state.reUseDimensions) {
      this.setState({reUseDimensions: !this.state.reUseDimensions});
    }
  }



  _actionsToDoIfCopyOk = (response: any, idCaddies: string) => {
    this.setState({
      selectedFile: response,
      fileRegisteredId: response.id,
      fromGallery: response.fromGallery,
      fileRegisteredCreationId: response.creationId,
      surfaceEmplacementId: response.surfaceEmplacementId,
      displayChargement: false,
      openDelete: false,
      openBroderie: false,
      statutVisuel: null
    }, () => {
      this._getFile(idCaddies);
      this._getPreview(idCaddies, true);
      this._canValidate();

      if(this.props.paniers[0].isModel3d) {
        this._generateGlbTexture(response.creationId, response.uploadDir, response.filesForCreationId);
      }
    });
  }

  _actionsToDoIfCopyNotOk = (response: any) => {
    if (response.data.message && response.status !== 401) {
      this.setState({
        displayContainerButtons: 'flex',
        displayChargement: false,
      });
      this._displayAlert(response.data.message, 'alert-danger-custom');
    }
    else if (response.status === 401) { sessionExpire(); }
    else {
      this.setState({
      showAlert: true,
      textAlert: 'Une erreur s\'est produite',
      classAlert: 'alert-danger alert-danger-custom',
      displayContainerButtons: 'flex',
      displayChargement: false,
    });
    }
  }

  handleChangeColors = (color: any) => {
    this.setState({ batAutoColor: color.hex });
  };

  handleChangeApplyOutline = (applyOutline: boolean, colorOutline: string) => {
    if(this.state.applyOutline !== applyOutline) {
      this.setState({applyOutline: applyOutline, colorOutline: colorOutline}, () => {
        if (this.state.applyOutline) {
          this._uploadImage(this.props.paniers, true);
        }
        this._resetCustomOptions();
      });
    }
  };

  onRollback = () => {
    this._uploadImage(this.props.paniers, true, true);
  }

submitHandleChangeColors = () => {
    this._uploadImage(this.props.paniers, true);
    this._resetCustomOptions();
  };

  changeOptionEvent = async (type: string, value: string, apply: boolean) => {
    this.setState({[type] : value}, () => {
      if(apply) {
        this.submitHandleChangeColors();
      }
    });
  };

  changeOutlineEvent = (isChange: boolean) => {
    if(isChange) {
      this._getOriginalFileInfos(this.props.paniers[0].idCaddies);
    }
  }

  _onUpdateCmjn = (idCaddies: string, cmjnData: cmjnData) => {
    this._updateCmjnByCaddiesSurface(idCaddies, cmjnData);
  }

  onSelectedFilesUpdatedByGallery = (selectedFile: GalleryFile) => {
    if (selectedFile !== this.state.selectedFile && !selectedFile.needReupload) {
      this.setState({ selectedFile: selectedFile }, () => {
        this._copyFile(this.props.paniers[0].idCaddies);
      });
    } else {
      this.setState({ selectedFile: selectedFile }, () => {
        this._uploadImage(this.props.paniers, false, false, true);
      });
    }
  }

  handleChangeRowValidationVisuelChecked = (keyVisuel: string, state: number) => {
    const array = {id: keyVisuel, value: state, galerieFichierId: this.state.fileRegisteredId, surfaceId:this.state.surfaceId, emplacementId: this.state.emplacementId};
    if (this.props.handleChangeRowValidationVisuelChecked) {
      this.props.handleChangeRowValidationVisuelChecked(array);
      this.setState({statutVisuel: state});
    }
  }

  handleChangeNonConformeChecked = (keyVisuel: string, state: boolean) => {
    const array = {id: keyVisuel, value: state, galerieFichierId: this.state.fileRegisteredId, surfaceId:this.state.surfaceId, emplacementId:this.state.emplacementId};
    this.props?.handleChangeNonConformeChecked(array);
  }

  handleChangeConformity = (etatConformity: boolean) => {
    const url = `${getHostApi()}/customers/${getUserId()}/orders/${this.props.order.idCommande}/items/${this.props.paniers[0].idCaddies}/surfaces/${this.state.surfaceId}/locations/${this.state.emplacementId}/images-bat-auto/${this.state.fileRegisteredId}/conformity-user`;
    axios.put(url, {etatConformity: etatConformity},
      getRequestConfig()).then((response) => {
      if (response.data) {
        this.setState({
          displayChargement: false
        });
        this._getConformity(this.props.paniers[0].idCaddies);
      }
    }).catch((error) => {
      if (error.response.status === 401) { sessionExpire(); }
    });
  }

  _getConformity = (idCaddies: string) => {
    if (this.state.fileRegisteredId) {
      const url = `${getHostApi()}/customers/${getUserId()}/orders/${this.props.order.idCommande}/items/${idCaddies}/surfaces/${this.state.surfaceId}/locations/${this.state.emplacementId}/images-bat-auto/${this.state.fileRegisteredId}/conformity-user`;
      axios.get(url,
        getRequestConfig()).then((response) => {
        if (response.data) {
          this.setState({
            dataConformity: {etatConformity: response.data.file_conformity_user_id, logsConformity: response.data.file_conformity_user_date, fileRegisteredId: this.state.fileRegisteredId}
          });
        }
      }).catch((error) => {
        if (error.response.status === 401) { sessionExpire(); }
      });
    }
  }

  _onCheckImageUsage = () => {
    const file = this.state.fileRegisteredCreationId + "-" + this.state.surfaceEmplacementId + ".tiff";
    const particulier = this.props.order.Societe !== "" ? "0" : "1";
    const siret = "";
    const tvaIntracom = this.props.order.numTVAIntraco ?? "";
    const codePostal = this.props.order.codePostal ?? "";
    const societe = this.props.order.Societe ?? "";
    const mail = this.props.order.Email ?? "";
    const quantite = this.props.nbArticles ?? "";
    const dataCustomer = `${particulier};${siret};${tvaIntracom};${codePostal};${societe};${mail};${quantite}`;
    const result = axios.post(`${getHostApi()}/customers/${getUserId()}/galleries/orders/${this.props.order.idCommande}/check-image-usage`,
      {
        file: file,
        dataCustomer: dataCustomer,
        galerieFichierVariablesId: this.state.originalFileInfos.gfvId
      },
      getRequestConfig()).then((response) => {
          return response.data;
    }).catch((error) => {
      console.log(error);
      if (error.response.status === 401) {
        sessionExpire();
      }
      return false;
    });

    return result;
  }

  _detectBackground = (fileIn: string) => {
    detectBackground({fileIn}).then((response: any) => {
      if (response && response.data) {
        this.setState({backgroundCanBeRemoved: response.data.hasBackground});
      }
    });
  }

  render() {
    const modificationsEnabled = (this.props.order.confirmationFichier == '0' || (this.props.isInternalUser && !this.props.customerView) ) && (this.props.order.validation_bat == '0' || ((this.props.order.StatutCommande == '5' || this.props.order.StatutCommande == '6') && this.props.isInternalUserAdmin && !this.props.customerView ) );
    const canViewFeatures = (this.props.isInternalUser && !this.props.customerView) || this.props.order.confirmationFichier == 0;
    const needValidate =  (!this.state.displayChargement && this.state.useBatAuto && this.props.order.confirmationFichier == 0 && this.state.fileRegisteredOriginalName)
      || (this.props.order.confirmationFichier == 1 && (this.props.isInternalUser && !this.props.customerView) && this.state.useBatAuto);
    const nonConforme = this.state.nonConforme;
    const needValidateClass = needValidate && this.state.statutVisuel != 1 && this.state.statutVisuel != 2  && this.state.statutVisuel != 3 && !nonConforme ? 'needValidationBatAuto' : '';
    const fusionMultiply = this.props.marquage.id == 1;
    const bgColor = this.state.cmjnCs?.isPersonnalise ? `#${this.state.cmjnCs.hexadecimal}` : `#${this.props.color.code1}`;
    const statutVisuel = this.state.statutVisuel;
    const showUploadBtn = (!this.state.fileRegisteredId || this.state.fileRegisteredId === '');
    const needParams = typeof this.state.pathLoadBat !== 'undefined' && !this.state.displayChargement ;
    const displayUploadBtn = (!this.state.fileRegisteredId || this.state.fileRegisteredId === '') && (modificationsEnabled);
    const displayClass = this.state.reuploadByOperator && !this.state.displayChargement ? {} : { display: this.state.displayContainerButtons };

    const reuploadAdminBatValide = (this.props.isInternalUserAdmin && !this.props.customerView) &&
      this.props.order.validation_bat == '2' && this.props.order.confirmationFichier == '1' &&
      (this.props.order.StatutCommande == '5' || this.props.order.StatutCommande == '6' || this.props.order.StatutCommande == '7');
    const reuploadBtnAdminBatValide = reuploadAdminBatValide && this.state.originalFileInfos?.statutLigneMarquageId === 2;

    let showGallerieComponent = false;
    if ((displayUploadBtn && !this.state.displayChargement) || ((getShopRefInStorage() !== 'DT' && this.state.reuploadByOperator && !this.state.displayChargement))) {
      showGallerieComponent = this.state.canGalerie && this.props.hasClientFiles;
    }


    const renderStatutLigneMarquageInvalid = () => {
      return (
        <div className={"alert alert-warning"}>
          Le statut de la ligne de marquage doit être en "Traitée pour l'impression" si vous souhaitez réenvoyer un fichier. Pensez à passer la ligne de marquage en "Prête à être imprimée" après l'upload
        </div>
      );
    };

    const renderAvertissement = () => {
      if (this.state.textAlert !== '') {
        return (
          <div className="align-self-end text-right">
            {renderAlert(this.state.showAlert, this.state.classAlert + ' ', this.state.textAlert)}
          </div>
        );
      }
    };
    const renderEndLine = () => {
      const selectedFileName = showGallerieComponent || (this.state.canGalerie && this.props.hasClientFiles) ? '' : this.state.selectedFileName;
      return (
        <div className="bootstrap-container d-flex flex-column">
          {renderAvertissement()}
          <BounceLoader id={`chargementEnCours-${this.props.identifier}`} loading={this.state.displayChargement} />
          <div className={`d-flex justify-content-center ${this.props.paniers[0].isModel3d ? 'flex-row' : 'flex-column flex-md-row'}   align-items-center containerImportButton w-100 container-${this.props.identifier}`} id={`container-${this.props.identifier}`}>
            <div className="d-flex align-items-center justify-content-end containerImportButtonFirstDiv w-100">
              {reuploadAdminBatValide  && ((this.props.fileRegisteredOriginalName && this.state.originalFileInfos?.statutLigneMarquageId !== 2) || this.state.originalFileInfos?.statutLigneMarquageId === 1) && renderStatutLigneMarquageInvalid()}
              {(displayUploadBtn || ((getShopRefInStorage() !== 'DT' && this.state.reuploadByOperator && !this.state.displayChargement) || (getShopRefInStorage() !== 'DT' && reuploadBtnAdminBatValide && !this.state.displayChargement) || (getShopRefInStorage() === 'DT' && this.props.canUploadFichierDT))) &&
                <div className={`py-2 px-0 text-center  align-items-center importButtonDiv mr-2 justify-content-end `}
                     id={`col2-${this.props.identifier}`} style={reuploadBtnAdminBatValide ? {} : displayClass}>
                  {(this.state.dimensionsModifiees && !this.state.isStylo &&  (this.state.reuploadByOperator && !this.state.displayChargement)) &&
                    <div className={'mb-3 d-flex align-items-center justify-content-center'} title={this.state.reUseDimensions ? 'Utiliser les dimensions modifées au prochain import' : 'Utiliser les dimensions maximales de la surface de marquage'}>
                      <SwitchBtn value={this.state.reUseDimensions} labelStyle={{margin: '0', zoom: '0.8'}} onChangeEvent={this.changeReUseDim} />
                      <span className={'ml-3 small text-left'}>
                        Réutiliser les<br/>
                        Dimensions modifées
                      </span>
                    </div>
                  }
                  {showGallerieComponent ?
                    <Gallery identifier={this.props.identifier} idCommande={this.props.order.idCommande} emplacementId={this.state.emplacementId} color={bgColor} surfaceId={this.state.surfaceId} surfaceNom={this.props.surface.nom}
                             display={this.state.displayContainerButtons} marquage={this.props.marquage} canGalerie={this.state.canGalerie} onSelectedFilesUpdated={this.onSelectedFilesUpdatedByGallery}
                             isInterne={(this.props.isInternalUser && !this.props.customerView)}
                             pictoId={this.props.pictogramme.id} onUpdateInput={this._onUpdateInput} selectedFileName={this.state.selectedFileName} authorizedFiles={this.props.authorizedFiles} idCaddies={this.props.paniers[0].idCaddies}/> :
                    <UploadBtn identifier={this.props.identifier} onUpdateInput={this._onUpdateInput} selectedFileName={selectedFileName} authorizedFiles={this.props.authorizedFiles} marquageNom={this.props.marquage.nom} surfaceId={this.state.surfaceId}/>
                  }
                </div>
              }
            </div>
            <ThumbnailUploadContainer
              data={{ ...this.state, ...this.props }}
              dimIsModified={this.state.dimensionsModifiees && !this.state.isStylo}
              onChangeOutlineProcessing={this.changeOutlineEvent}
              changeOptionEvent={this.changeOptionEvent}
              onDeleteFile={this._onDeleteFile}
              onCheckImageUsage={this._onCheckImageUsage}
              resetCustomOptions={this._resetCustomOptions}
              handleChangeColors={this.handleChangeColors}
              onApplyOutline={this.handleChangeApplyOutline}
              submitHandleChangeColors={this.submitHandleChangeColors}
              getPreview={this._getPreview}
              onDownloadFile={this._onDownloadFile}
              updateDimensions={this._updateDimensions}
              nonConforme={nonConforme}
              onRollback={this.onRollback}
              onUpdateCmjn={this._onUpdateCmjn}
              activateCheckImageUsage={this.props.activateCheckImageUsage}
              backgroundCanBeRemovedConditions={!displayUploadBtn && !this.state.displayChargement && this.state.backgroundCanBeRemoved}
            />
            {(((needValidate && !showUploadBtn && canViewFeatures && needParams) || reuploadBtnAdminBatValide) && this.state.originalFileInfos && this.state.originalFileInfos.quality ) &&
              <>
              { this.state.originalFileInfos.quality?.quality === 'bad' ? (
                <div className={"validationBatAutoModaleWrapper p-2 p-lg-0 needReplaceBadQualityImg"} id={`validationBatAutoModaleWrapper-${this.props.identifier}`}>
                  <div className={'p-2 red font-italic'}>{badQualityMsg()}</div>
                </div>
                  ) : (
            <div className={"validationBatAutoModaleWrapper p-2 p-lg-0 " +needValidateClass} id={'validationBatAutoModaleWrapper-' + this.props.identifier}>
                <ModalFileVerification
                  authorizedFiles={this.props.authorizedFiles}
                  surfaceEmplacementId={this.state.surfaceEmplacementId}
                  surfaceId={this.state.surfaceId}
                  emplacementId={this.state.emplacementId}
                  handleChangeConformity={this.handleChangeConformity}
                  handleChangeApplyOutline={this.handleChangeApplyOutline}
                  fusionMultiply={fusionMultiply}
                  bgColor={bgColor}
                  statutVisuel={statutVisuel}
                  nonConforme={nonConforme}
                  data={{...this.state, ...this.props}}
                  handleChangeRowValidationVisuelChecked={this.handleChangeRowValidationVisuelChecked}
                  handleChangeNonConformeChecked={this.handleChangeNonConformeChecked}
                  reuploadBtnAdminBatValide={reuploadBtnAdminBatValide}
                  getPreview={this._getPreview}
                  onReupload={this._onUpdateInput}
                />
            </div>
                )}
              </>
              }
          </div>
        </div>
      );
    };
    return renderEndLine();
  }
}
